import { render, staticRenderFns } from "./ProductCustomPropertiesPopupIframe.vue?vue&type=template&id=39cf4cab&"
import script from "./ProductCustomPropertiesPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomPropertiesPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports